module.exports = __webpack_public_path__ + "static/img/question-circle-o.9bdb3efa.svg";